export default __webpack_public_path__ + "static/media/contactus.fef66f22.jpg";